<!-- eslint-disable vue/no-mutating-props -->
<template>
    <div class="Kişi_detay">
        <AppMain>





            <div class="nk-content ">
        <div class="container-fluid">
            <div class="nk-content-inner">
                <div class="nk-content-body">
                    <div class="nk-block-head nk-block-head-sm">
                        <div class="nk-block-between g-3">
                            <div class="nk-block-head-content">

                            

                                <h3 class="nk-block-title page-title">Kişi  / <strong class="text-primary small">{{ kisiler.adsoyad }}</strong></h3>
                                <div class="nk-block-des text-soft">
                                    <ul class="list-inline">
                                        <li>Kişi  ID: <span class="text-base">{{ kisiler.id }}</span></li>
                                        <li>Güncelleme Tarihi: <span class="text-base">{{ kisiler.duzenleme_tarih }}</span></li>
                                    </ul>
                                </div>
                            </div>
                            <div class="nk-block-head-content">
                                <router-link to="/kisiler"  class="btn btn-outline-light bg-white d-none d-sm-inline-flex"><em
                                        class="icon ni ni-arrow-left"></em><span>Kişiler</span>
                                    </router-link>
                                  </div>
                        </div>
                    </div>
                    <div class="nk-block">
                        <div class="card card-bordered">
                            <div class="card-aside-wrap">
                                <div class="card-content">
                                    <ul class="nav nav-tabs nav-tabs-mb-icon nav-tabs-card">
                                        
                                        <li class="nav-item">
                                            <a  href="#" :class="{ 'active': aktifSekme === 'bilgiler','nav-link':true}"
                                            @click="aktifSekmeDegistir('bilgiler')">
                                                <em class="icon ni ni-user-circle"></em>
                                                <span>Kişi Bilgileri</span>
                                            </a>
                                        </li>

                                        

                                        
                                    <li class="nav-item">
                                                    <a  href="#" :class="{ 'active': aktifSekme === 'gorusmebilgiler','nav-link':true}"
                                                    @click="aktifSekmeDegistir('gorusmebilgiler')">
                                                        <em class="icon ni ni-update"></em>
                                                        <span>Görüşme Bilgiler</span>
                                                    </a>
                                                </li>
                                    


                                        
                                   
                                        

                                     
                                        
                                     
                                        <li class="nav-item nav-item-trigger d-xxl-none">
                                            <a href="#" class="toggle btn btn-icon btn-trigger" data-target="userAside">
                                            <em class="icon ni ni-user-list-fill"></em></a>
                                        </li>
                                    </ul>

                               
                                    <div class="card-inner" v-show="aktifSekme === 'bilgiler'">
                                        <div class="nk-block">
                                            <div class="nk-block-head">
                                                <h5 class="title">Kişi Bilgileri</h5>
                                               
                                            </div>
                                            <div class="profile-ud-list">
                                                


                                                
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Ad Soyad </span><span class="profile-ud-value">{{ kisiler.adsoyad }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Telefon </span><span class="profile-ud-value">{{ kisiler.telefon }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">E-mail </span><span class="profile-ud-value">{{ kisiler.email }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Adres </span><span class="profile-ud-value">{{ kisiler.adres }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Not </span><span class="profile-ud-value">{{ kisiler.not }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Görev </span><span class="profile-ud-value">{{ kisiler.gorev }}</span></div>
                                                                </div>
                                    
                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Konuştuğu Dİl </span><span class="profile-ud-value">{{ kisiler.dil }}</span></div>
                                                                </div>
                                    
                                    
                                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Profil</span><span class="profile-ud-value">     <img 
                                                                  
                                                                    class="rounded img-cover mb-2 h-50" 
                                                                    :src="$globalVariable.uploadUrl + kisiler.gorsel" 
                                                                    alt="Kartvizit Ön Görsel" 
                                                                    @click="openLightbox($globalVariable.uploadUrl + kisiler.gorsel)"
                                                                /></span></div>
                                                                </div>

                                                       
                                    
                                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Kartvizit Görsel Ön </span><span class="profile-ud-value">     <img 
                                                             
                                                                class="rounded img-cover mb-2 h-50" 
                                                                :src="$globalVariable.uploadUrl + kisiler.kartviziton" 
                                                                alt="Kartvizit Ön Görsel" 
                                                                @click="openLightbox($globalVariable.uploadUrl + kisiler.kartviziton)"
                                                            /></span></div>
                                                                </div>

                                                                <div class="profile-ud-item">
                                                                    <div class="profile-ud wider"><span class="profile-ud-label">Kartvizit Görsel Arka </span><span class="profile-ud-value">     <img 
                                                                  
                                                                    class="rounded img-cover mb-2 h-50" 
                                                                    :src="$globalVariable.uploadUrl + kisiler.kartvizitarka" 
                                                                    alt="Kartvizit Ön Görsel" 
                                                                    @click="openLightbox($globalVariable.uploadUrl + kisiler.kartvizitarka)"
                                                                /></span></div>
                                                                </div>
                                    
                                    
                                                 
                                                    

                                            </div>
                                        </div>
                                        <div class="nk-block">
                                            <div class="nk-block-head nk-block-head-line">
                                                <h6 class="title overline-title text-base">Kayıt Bilgileri</h6>
                                            </div>
                                            <div class="profile-ud-list">
                                                <div class="profile-ud-item">
                                                    <div class="profile-ud wider"><span class="profile-ud-label">Oluşturma Tarihi</span><span class="profile-ud-value">{{ kisiler.olusturma_tarih }}</span></div>
                                                </div>
                                                <div class="profile-ud-item">
                                                    <div class="profile-ud wider"><span class="profile-ud-label">Son Düzenleme Tarihi</span><span class="profile-ud-value">{{ kisiler.duzenleme_tarih }}</span>
                                                    </div>
                                                </div>
                                                
                                            </div>
                                        </div>
                                        <div class="nk-divider divider md"></div>
                                      
                                    </div>
                                    

                                    
                                    
                                    <div class="card-inner" v-show="aktifSekme === 'gorusmebilgiler'">
                                        <div class="nk-block">
                                       

                                            <div class="d-flex justify-content-between mt-4 mb-2">
                                                    <h6>Görüşme Bilgiler</h6>
                                                    <a  @click="gorusmebilgiler_ekle" class="btn btn-primary" >
                                                        <span>Görüşme Bilgi Ekle</span>
                                                        <em class="icon ni ni-plus"></em>
                                                    </a>
                                                </div>

                                                <gorusmebilgiCard :gorusmebilgiler="gorusmebilgiler" :duzenle="gorusmebilgiler_duzenle" :detay="gorusmebilgiler_duzenle"   :formKaydetSonrasi="kisilerDetayGetir"  @update:gorusmebilgiler="gorusmebilgilerGuncelle" />


                                                <div class="modal fade modal-close-out show" style="display: block;" v-if="gorusmebilgiler.modal">
                                                <div class="modal-dialog modal-dialog-centered">
                                                <div class="modal-content">
                                                    <div class="modal-header">
                                                    <h5 class="modal-title" v-if="gorusmebilgiler.islem == 'ekle'"> Yeni Görüşme Bilgi Ekle </h5>
                                                    <h5 class="modal-title" v-if="gorusmebilgiler.islem == 'duzenle'">Görüşme Bilgi Düzenleme </h5>
                                                    <button type="button" class="btn-close" @click="gorusmebilgiler_iptal"></button>
                                                    </div>
                                                    <div class="modal-body">

                                                        <gorusmebilgiForm :formIslem="gorusmebilgiler.islem" :formData="gorusmebilgiler.secili"
                                                        :formKaydetSonrasi="musterilerDetayGetir" :formIptal="gorusmebilgiler_iptal" />


                                                    </div>
                                                </div>

                                                </div>
                                                </div>
                                         
                                        </div>
                                    </div>
                                    
                          
                             
                                      



                                </div>
                                <div class="card-aside card-aside-right user-aside toggle-slide toggle-slide-right toggle-break-xxl toggle-screen-xxl"
                                    data-content="userAside" data-toggle-screen="xxl" data-toggle-overlay="true"
                                    data-toggle-body="true">
                                    <div class="card-inner-group" data-simplebar="init">
                                        <div class="simplebar-wrapper" style="margin: 0px;">
                                            <div class="simplebar-height-auto-observer-wrapper">
                                                <div class="simplebar-height-auto-observer"></div>
                                            </div>
                                            <div class="simplebar-mask">
                                                <div class="simplebar-offset" style="right: 0px; bottom: 0px;">
                                                    <div class="simplebar-content-wrapper" tabindex="0" role="region"
                                                        aria-label="scrollable content"
                                                        style="height: auto; overflow: hidden;">
                                                        <div class="simplebar-content" style="padding: 0px;">
                                                            <div class="card-inner">
                                                                <div class="user-card user-card-s2">
                                                                    <div class="user-avatar lg bg-primary"> 
                                                                         <img :src="$globalVariable.uploadUrl + kisiler.logo"
                                                                            @error="$globalVariable.varsayilanGorsel" class="img-fluid rounded-xl">
                                                                        </div>
                                                                    <div class="user-info">
                                                                        <div
                                                                            class="badge bg-outline-light rounded-pill ucap">
                                                                            {{ kisiler.adsoyad }}</div>
                                                                        <h5> {{ kisiler.adsoyad  }}</h5><span
                                                                            class="sub-text">{{ kisiler.adsoyad }}</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="card-inner card-inner-sm">
                                                                <ul class="btn-toolbar justify-center gx-1">
                                                                    <li><a href="#" class="btn btn-trigger btn-icon"><em
                                                                                class="icon ni ni-shield-off"></em></a>
                                                                    </li>
                                                                    <li><a href="#" class="btn btn-trigger btn-icon"><em
                                                                                class="icon ni ni-mail"></em></a></li>
                                                                    <li><a href="#" class="btn btn-trigger btn-icon"><em
                                                                                class="icon ni ni-download-cloud"></em></a>
                                                                    </li>
                                                                   
                                                                    <li><a href="#"
                                                                            class="btn btn-trigger btn-icon text-danger"><em
                                                                                class="icon ni ni-na"></em></a></li>
                                                                </ul>
                                                            </div>
                                                        
                                                            <div class="card-inner">
                                                                <div class="row text-center">
                                                                    <div class="col-6">
                                                                        <div class="profile-stats"><span
                                                                                class="amount">kisiler</span><span
                                                                                class="sub-text">{{ kisiler.adsoyad }}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div class="col-6">
                                                                        <div class="profile-stats"><span
                                                                                class="amount">kisiler</span><span
                                                                                class="sub-text">{{ kisiler.adsoyad }}</span>
                                                                        
                                                                    </div>
                                                                  
                                                                </div>
                                                            </div>

                                           

                                                            <div class="card-inner">
                                                                <h6 class="overline-title-alt mb-2">Kayıt Bilgileri</h6>
                                                                <div class="row g-3">
                                                                    <div class="col-6"><span class="sub-text">Oluşturma Tarihi:</span><span>{{ kisiler.olusturma_tarih }}</span></div>
                                                                  
                                                                    <div class="col-6"><span class="sub-text">Son Düzenleme Tarihi:</span><span>{{ kisiler.duzenleme_tarih }}</span></div>
                                                                </div>
                                                            </div>
                                                          
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="simplebar-placeholder" style="width: auto; height: 815px;">
                                            </div>
                                        </div>
                                        <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
                                            <div class="simplebar-scrollbar" style="width: 0px; display: none;"></div>
                                        </div>
                                        <div class="simplebar-track simplebar-vertical" style="visibility: hidden;">
                                            <div class="simplebar-scrollbar" style="height: 0px; display: none;"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
   
</div>

                              
<vue-easy-lightbox
      :visible="visible"
      :imgs="images"
      :index="index"
      @hide="closeLightbox"
    />
              







            </AppMain>
        </div>
</template>
  
<script>
import axiosCustom from "@/services/axiosCustom";
import { yetkiKontrol } from '@/services/yetkiKontrol';
import AppMain from "@/components/AppMain.vue";

    
import gorusmebilgiCard from "@/components/gorusmebilgiler/gorusmebilgiCard.vue";
import gorusmebilgiForm from "@/components/gorusmebilgiler/gorusmebilgiForm.vue";

import VueEasyLightbox from 'vue-easy-lightbox';


export default {
    name: "kisilerDetayView",
    components: {
        AppMain,
            
        gorusmebilgiCard, 
        gorusmebilgiForm,
        VueEasyLightbox
        
    },
    data() {
        return {
            kisiler: [],
           
            aktifSekme: 'bilgiler',
            hareketSayfadaKayit: 10,
            hareketSeciliSayfa: 1,

            
            gorusmebilgiler: {
                tumu: [],
                secili: null,
                seciliSayfa: 1,
                sayfadaKayit: 5,
                arananKelime: "",
                islem: 'ekle',
                modal: false,
            },
            
          
            visible: false,
      images: "",
      index: 0,


        };
    },
    mounted() {
        this.kisilerDetayGetir();
    },

    methods: {
        yetki_kontrol(yetki) {
            return yetkiKontrol(yetki);
        },
       
        kisilerDetayGetir() {
            const id = this.$route.params.id;

            axiosCustom
                .get(`kisiler/detay/${id}`)
                .then((response) => {
                    this.kisiler = response.data;
           
                    
                    this.gorusmebilgiler.tumu = response.data.gorusmebilgiler;
                    this.gorusmebilgiler.modal = false;
                    

                    

                    
                })
                .catch((error) => {
                    console.error("Veri çekme hatası: ", error);
                });
        },

    
        aktifSekmeDegistir(sekme) {
            this.aktifSekme = sekme;
            const id = this.$route.params.id;
            this.$router.push('/kisiler/'+id+'/'+sekme);
        },




        
        gorusmebilgilerGuncelle(veriler) {
            this.gorusmebilgiler = veriler;
        },
        gorusmebilgiler_ekle() {
            this.gorusmebilgiler.secili = {'kisi':this.kisiler.id};
            this.gorusmebilgiler.islem = "ekle";
            this.gorusmebilgiler.modal = true;
            this.aktifSekmeDegistir("gorusmebilgiler");
        },
        gorusmebilgiler_duzenle(veri) {
            this.$router.push('/gorusmeform/'+veri.id);
        },
        gorusmebilgiler_iptal() {
            this.gorusmebilgiler.secili = {};
            this.gorusmebilgiler.modal = false;
        },
        


        openLightbox(imageUrl) {
      this.images = [imageUrl]; // Lightbox'a dinamik URL'yi ekle
      this.index = 0; // Başlangıçta ilk resmi göster
      this.visible = true; // Lightbox'ı görünür yap
    },
    closeLightbox() {
      this.visible = false;
    },


        



    }
};
</script>
  

<style>
.image-gallery {
  display: flex;
  flex-wrap: wrap;
}
</style>   